'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $("[product-priority-value]", this).each(function () {
        $(this).on("change", function () {
            var itemId = $(this).attr('product-priority-id');
            var that = this;
            productPriority.setProductPriority(itemId, this.value).done(function (result) {
                if (result > 0) {
                    _notify2.default.success(resx.App.PriorityHasBeenSet);
                } else {
                    _notify2.default.success(resx.App.PriorityHasBeenDeleted);
                }
                $(that).val(result);
            }).fail(function (result) {
                _notify2.default.error(resx.Common.AjaxError);
            });
        });
    });
};

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("Common", "App");

var $ = require("jquery");
var productPriority = abp.services.api.productPriority;

;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/productPriority.js
// module id = 448
// module chunks = 0